import script from "./UserDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetail.vue?vue&type=script&setup=true&lang=js"

import "./UserDetail.vue?vue&type=style&index=0&id=ec55b4a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec55b4a2"]])

export default __exports__